import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BytesPipe } from 'src/app/modules/pipes/bytes.pipe';
import { ResolveDurationPipe } from './resolve-duration.pipe';
import { AddressPipe } from './address.pipe';
import { DurationPipe } from './duration.pipe';
import { RrulePipe } from './rrule.pipe';
import { AssignmentActionPipe } from './assignment-action.pipe';
import { ResolveTotalPipe } from './resolve-total.pipe';
import { TimeDistancePipe } from './time-distance.pipe';



@NgModule({
  declarations: [ 
    AssignmentActionPipe, 
    BytesPipe, 
    ResolveDurationPipe, 
    ResolveTotalPipe,
    AddressPipe, 
    DurationPipe, 
    RrulePipe, 
    TimeDistancePipe ],
  providers: [
    BytesPipe, 
    ResolveDurationPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AssignmentActionPipe, 
    BytesPipe, 
    ResolveDurationPipe, 
    ResolveTotalPipe, 
    AddressPipe, 
    DurationPipe, 
    RrulePipe,
    TimeDistancePipe
  ]
})
export class PipesModule { }
